import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
//import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  },
  {
    path: '/not-found',
    name: 'Not Found',
    component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue')
  },
  {
    path:'/category/:slug', 
    name: 'Category', 
    component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue')
  },
  {
    path:'/post/:slug', 
    name: 'Post', 
    component: () => import(/* webpackChunkName: "post" */ '../views/Post.vue')
  }, 
  {
    path: '/:slug',
    name: 'Page',
    component: () => import(/* webpackChunkName: "page" */ '../views/Page.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes, 
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

export default router
